import React, { PropsWithChildren } from 'react'

import style from './style.scss'

interface IProps {
  type?: 'info' | 'error' | 'warning' | 'success'
}

const Message = ({ type = 'info', children }: PropsWithChildren<IProps>) => {
  return (
    <div className={`${style.messageContainer} ${style[type]}`}>{children}</div>
  )
}

export default Message
